import 'prop-types';
import * as React from 'react';
import { AriaLiveRegionsContext } from '../components/Theme/AriaLiveRegions.js';

var useAriaLiveRegion = function useAriaLiveRegion(_ref) {
  var content = _ref.content,
      showing = _ref.showing,
      type = _ref.type;
  var dispatch = React.useContext(AriaLiveRegionsContext);
  React.useEffect(function () {
    var payload = !showing ? void 0 : content;
    dispatch({
      type: type,
      payload: payload
    });
  }, [dispatch, content, showing, type]);
};

export { useAriaLiveRegion };
